import classNames from 'classnames';
import React from 'react';
import Input from '~/components/Input';
import Select from '~/components/Select';

type SelectProps = {
    options?: { name: string; label: string }[];
    value?: string;
    [x: string]: any;
};
export const SelectOption: React.FC<SelectProps> = ({
    options = [],
    placeholder = 'Please select value',
    maxLength,
    value,
    onChange,
    label,
    ...otherProps
}: SelectProps) => {
    return (
        <div className="form-group">
            <Select
                value={value || ''}
                options={[...options?.map((item) => ({ label: item.label, value: item.name }))]}
                {...otherProps}
                defaultValue={''}
                onChange={(valueSelect) => onChange(valueSelect)}
            ></Select>
        </div>
    );
};
type TextProps = {
    [x: string]: any;
};
export const TextOption: React.FC<TextProps> = ({
    placeholder = 'Please enter value',
    label,
    maxlength,
    type,
    onChange,
    ...otherProps
}: TextProps) => {
    return (
        <div className="form-group ">
            <Input
                className="form-control"
                placeholder={placeholder}
                maxLength={maxlength}
                type={type}
                {...otherProps}
                onChange={(e) => onChange(e?.target?.value)}
            />
            <p className="text-gray-400"> {maxlength && <span>Max {maxlength} characters.</span>}</p>
        </div>
    );
};

export const RadioOption: React.FC<TextProps> = () => {
    return (
        <div className="form-group">
            <Input className="form-control" type="number" />
        </div>
    );
};

export type ElementOptionsCustomization = {
    Select: typeof SelectOption;
    Text: typeof TextOption;
    Radio: typeof RadioOption;
};
const ElementOptions: ElementOptionsCustomization = {
    Select: SelectOption,
    Text: TextOption,
    Radio: RadioOption
};

// ElementOptions.Number = Reject;
// ElementOptions.Text = Export;
// ElementOptions.Radio = Cancel;
// ElementOptions.Submit = Submit;

export default ElementOptions;
